// extracted by mini-css-extract-plugin
export default {"formTitle":"PersonalForm_formTitle__V413r","recaptcha":"PersonalForm_recaptcha__1bpiV"};